<template>
  <div class="tweet">
    <div class="embed-col">
      <div class="embed" v-html="tweetHtml"></div>
    </div>
    <div class="options-col">
      <div
        class="tweet-action then-card"
        :class="{'disabled-action': tweet.has_liked, 'cannot-action': tweet.cannot_like_recommendation}"
        @click="likeTweet"
      >
        <img src="/images/icons/tw-like.svg" class="like-img" />
        <div class="like-label">Like</div>
        <div class="clearfix"></div>
      </div>
      <template v-if="!tweet.cannot_like_recommendation">
        <img src="/images/icons/snap.svg" class="earn-snaps-img" />
        <div class="earn-snaps-label">{{ tweet.like_snaps }}</div>
      </template>

      <div v-if="tweet.has_liked" class="tweet-checked">
        <div class="tweet-check-icon">
          <i class="material-icons">check</i>
        </div>
        <div class="tweet-check-label">Earned</div>
        <div class="clearfix"></div>
      </div>

      <div class="clearfix"></div>

      <div
        class="tweet-action then-card"
        :class="{'disabled-action': tweet.has_retweeted, 'cannot-action': tweet.cannot_retweet_recommendation}"
        @click="retweetTweet"
      >
        <img src="/images/icons/tw-retweet.svg" class="retweet-img" />
        <div class="like-label">Retweet</div>
        <div class="clearfix"></div>
      </div>
      <template v-if="!tweet.cannot_retweet_recommendation">
        <img src="/images/icons/snap.svg" class="earn-snaps-img" />
        <div class="earn-snaps-label">{{ tweet.retweet_snaps }}</div>
      </template>

      <div v-if="tweet.has_retweeted" class="tweet-checked">
        <div class="tweet-check-icon">
          <i class="material-icons">check</i>
        </div>
        <div class="tweet-check-label">Earned</div>
        <div class="clearfix"></div>
      </div>

      <div class="clearfix"></div>
    </div>

    <div class="clearfix"></div>
  </div>
</template>

<script>
import Back from "../../modules/Back";
export default {
  name: "Tweet",
  props: ["tweet"],
  data: function() {
    return {
      tweetHtml: null
    };
  },
  mounted() {
    var that = this;
    console.log("tweet", this.tweet);
    jsonp(
      "https://publish.twitter.com/oembed?url=" + this.tweet.tw_url,
      function(data) {
        that.tweetHtml = data.html;
      }
    );
  },
  methods: {
    async likeTweet() {
      if (this.tweet.has_liked || this.tweet.cannot_like_recommendation) {
        return;
      }

      console.log("likeTweet", this.tweet);
      const response = await Back.likeTweet(this.tweet.id);
      if (response) {
        this.tweet.has_liked = true;
        this.$store.commit("addPoints", this.tweet.like_snaps);
        this.$toasted.show(
          "Great! You liked this tweet and earned " +
            this.tweet.like_snaps +
            " snaps!",
          {
            icon: "check_circle",
            position: "bottom-center",
            duration: 3000
          }
        );
      } else {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      }
      console.log("likeTweet response", response);
    },
    async retweetTweet() {
      if (
        this.tweet.has_retweeted ||
        this.tweet.cannot_retweet_recommendation
      ) {
        return;
      }
      console.log("retweetTweet", this.tweet);
      const response = await Back.retweetTweet(this.tweet.id);
      if (response) {
        this.tweet.has_retweeted = true;
        this.$store.commit("addPoints", this.tweet.retweet_snaps);
        this.$toasted.show(
          "Great! You retweeted this tweet and earned " +
            this.tweet.retweet_snaps +
            " snaps!",
          {
            icon: "check_circle",
            position: "bottom-center",
            duration: 3000
          }
        );
      } else {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      }
      console.log("retweetTweet response", response);
    }
  }
};

function jsonp(url, callback) {
  var callbackName = "jsonp_callback_" + Math.round(100000 * Math.random());
  window[callbackName] = function(data) {
    delete window[callbackName];
    document.body.removeChild(script);
    callback(data);
  };

  var script = document.createElement("script");
  script.src =
    url + (url.indexOf("?") >= 0 ? "&" : "?") + "callback=" + callbackName;
  document.body.appendChild(script);
}
</script>

<style lang="scss" scoped>
.tweet {
  padding: 16px 0 20px 40px;
}
.embed-col {
  float: left;
  width: 540px;
}
.options-col {
  float: left;
  width: 400px;
  padding-top: 30px;
}

.heading-budget {
  padding-top: 30px;
}

.input-label {
  float: left;
  width: 170px;
}
.input-box {
  float: left;
  width: 550px;
  font-family: $font-family;
}

.input-label {
  padding: 20px 12px 20px 0;
  font-size: 14pt;
  line-height: 1.4em;
  font-family: $font-family;
}
.input-label-small {
  width: 140px;
  padding-left: 20px;
}
.input-box-small {
  width: 160px;
}

.field-instructions {
  padding-bottom: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: #777;
  font-family: $font-family;
}
.field-instructions-budget {
  padding-left: 20px;
}
.field-error {
  padding-bottom: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: rgb(235, 96, 96);
}

.like-img {
  float: left;
  width: 24px;
  margin: 1px 8px 0 0;
}
.retweet-img {
  float: left;
  width: 25px;
  margin: 1px 8px 0 -1px;
}
.like-label {
  float: left;
  margin-top: 0px;
}

.retweet-reach {
  font-size: 13pt;
  color: #999;
  padding-left: 32px;
}

.save-button {
  margin: 12px 0 0 18px;
  background: #daedff;
  color: #2196f3;
}

.tweet-action {
  float: left;
  width: 150px;
  padding: 0.25em 0 0.35em 0;
  font-weight: 600;
  font-size: 16pt !important;
  font-family: "Source Sans Pro";
  color: #222;
  cursor: pointer;
}
.tweet-action:hover {
  opacity: 0.7;
}

.earn-snaps-label {
  float: left;
  width: 48px;
  margin: 7px 0 0 6px;
  font-family: $font-family;
  font-size: 13.5pt;
  font-weight: 600;
  color: #ff7043;
}
.earn-snaps-img {
  float: left;
  width: 20px;
  margin: 16px 0 0 0px;
}

.tweet-checked {
  float: left;
}
.tweet-check-icon {
  float: left;
  margin: 8px 4px 0 0px;
  font-size: 9pt !important;
  color: $color-blue;
}
.tweet-check-label {
  float: left;
  margin-top: 8px;
  font-size: 12pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
  color: $color-blue;
}

// 6:09 338

.disabled-action {
  opacity: 1;
  cursor: default !important;

  .like-label,
  .retweet-label {
    color: $color-blue !important;
  }
}
.disabled-action:hover {
  opacity: 0.6 !important;
}

.cannot-action {
  opacity: 0.6;
  cursor: default !important;
}
.cannot-action:hover {
  opacity: 0.6 !important;
}
</style>
